<template>
  <q-page
    class="ws-min-height-1000 window-width row justify-center items-center"
  >
    <div class="col row justify-center items-center q-pa-md full-width">
      <div class="container">
        <div class="row">
          <div class="col">
            <h5 class="title">
              <b>404</b> {{ $t('page404.title') }}
            </h5>
            <p>{{ $t('page404.message') }}</p>
            <ws-button
              :type="WsButtonEnum.Type.PRIMARY"
              :size="WsButtonEnum.Size.LARGE"
              :element="WsButtonEnum.Element.A"
              :label="$t('page404.action_btn')"
              href="/"
            />
          </div>
        </div>
      </div>
    </div>
  </q-page>
</template>

<script lang="ts">
import {Component, Vue} from 'vue-property-decorator';
import {QPage} from 'quasar';
import { WsButton, WsButtonEnum } from '@odin/components-vue2';

@Component({
  components: {
    QPage,
    WsButton,
  },
})
export class Page404 extends Vue {
  WsButtonEnum = WsButtonEnum;
}

export default Page404;
</script>

<style lang="scss" scoped>
.title {
  ::v-deep b {
    font-size: 250%;
    color: $ws-red;
    margin-right: 16px;
  }
}
.ws-button:hover {
  text-decoration: none;
}
</style>
